/*
 * @Description: Description
 * @Autor: Chen
 * @Date: 2021-01-15 10:19:28
 * @LastEditors: chen
 * @LastEditTime: 2021-02-23 11:46:03
 */
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { CoreModule } from './core/core.module';
import { httpInterceptorProviders } from './services/http-interceptors';
import { NzCarouselModule } from 'ng-zorro-antd/carousel';
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CoreModule,
    NzCarouselModule
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    httpInterceptorProviders
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
